import { getOrigin } from 'owa-url';
import { getQueryStringParameters } from 'owa-querystring';
import { setIsDeepLinkAction } from 'owa-calendar-actions';
import {
    lazyNavigateToAddCalendarPanel,
    lazyOpenAddCalendarsPane,
    lazySetAndNavigateWebImport,
    AddCalendarsMenuItemId,
} from 'owa-calendar-addcalendar';
import { getUserConfiguration } from 'owa-session-store';

/**
 * Route handling for Add Calendar dialog
 */
export default function addCalendarRouteHandler() {
    const path = location.pathname.split('/');
    setIsDeepLinkAction(true);

    if (location.search) {
        const { url, name } = getQueryStringParameters();

        if (url) {
            lazySetAndNavigateWebImport.importAndExecute(url, name);

            const newUrl = `${getOrigin()}${location.pathname}`;
            window.history.replaceState(null, null, newUrl);
        }
    }

    if (
        path.includes(AddCalendarsMenuItemId.TeamSnap.toLowerCase()) &&
        getUserConfiguration()?.PolicySettings?.TeamsnapCalendarsEnabled
    ) {
        lazyNavigateToAddCalendarPanel.importAndExecute(AddCalendarsMenuItemId.TeamSnap);
    } else if (path.includes(AddCalendarsMenuItemId.Schools.toLowerCase())) {
        lazyNavigateToAddCalendarPanel.importAndExecute(AddCalendarsMenuItemId.Schools);
    } else if (
        path.includes(AddCalendarsMenuItemId.Personal.toLowerCase()) &&
        getUserConfiguration()?.PolicySettings?.PersonalAccountCalendarsEnabled
    ) {
        lazyNavigateToAddCalendarPanel.importAndExecute(AddCalendarsMenuItemId.Personal);
    }

    lazyOpenAddCalendarsPane.importAndExecute('DeepLink');
}
